(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.saveButton = this.querySelector('.cart-summary__save-note');
      this.textarea = this.querySelector('textarea');

      if (this.saveButton) {
        this.saveButton.addEventListener('click', () => this.saveNote());
      }
    }

    /**
     * Saves the cart note with loading and success feedback
     */
    async saveNote() {
      if (!this.textarea || !this.saveButton) return;

      this.saveButton.textContent = this.saveButton.dataset.savingText;
      this.saveButton.disabled = true;

      try {
        const body = JSON.stringify({ note: this.textarea.value });
        await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });

        this.saveButton.textContent = this.saveButton.dataset.savedText;

        setTimeout(() => {
          this.saveButton.textContent = this.saveButton.dataset.defaultText;
          this.saveButton.disabled = false;
        }, 2000);
      } catch (error) {
        this.saveButton.textContent = this.saveButton.dataset.defaultText;
        this.saveButton.disabled = false;
      }
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
